import { createAction } from '@reduxjs/toolkit'

export const setAIImages = createAction<string[]>('aiImage/setAIImages')
